<template>
  <div v-if="student">
    <card class="basicCard">
      <div class="row">
        <div class="col-sm-1 text-center">
          <img
            id="profilePic"
            :src="profilePicPath"
            alt="Profile Picture"
            width="150"
            height="150"
          />
        </div>
        <div
          class="col-sm-3"
          style="display: flex; align-items: center; padding-left: 4em"
        >
          <div class="row">
            <div class="col-sm-12">
              <h5>{{ currentProgram.name }} Pilot</h5>
            </div>
            <div class="col-sm-12">
              <h1>{{ student.full_name }}</h1>
            </div>
            <div class="col-sm-12">
              <h5>Instructor: {{ instructor.full_name }}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-5 align-self-center">
          <div class="row text-center" style="width: 100%">
            <div class="col-sm-12">
              <button class="lightGreyButton" @click="goToDocuments">
                Documents
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-2"></div>
        <div class="col-sm-1 align-items-center">
          <img
            :src="rightLogoPath"
            alt="Profile Picture"
            width="100"
            height="100"
          />
        </div>
      </div>
    </card>
    <card class="basicCard">
      <div class="row">
        <div class="col-sm-8 align-items-center">
          <div class="customCard align-items-center">
            <div>
              <div class="row">
                <div class="col-sm-6 text-center hashTag">#VentureWest</div>
              </div>
              <h1 style="padding: 0.25em 0">Pilot Static System</h1>
              <h4>This Weeks Recommended Training</h4>
              <h4>Review For {{ student.full_name }}</h4>
              <button class="arrowBtn" @click="goToStaticSystem">
                &#8599;
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="customCard">
            <div class="row">
              <div class="col-sm-9">
                <h5 class="cardTitles">Current Program</h5>
                <h1>{{ currentProgram.name }}</h1>
                <div style="padding-bottom: 20px">
                  Start Date:
                  {{ currentProgram.startDate.toLocaleDateString() }} | End
                  Date: {{ currentProgram.endDate.toLocaleDateString() }}
                </div>
              </div>
              <div class="col-sm-3 text-center">
                <h1 class="redText">{{ calculateDaysLeft() }}</h1>
                <div>
                  <h5 class="daysLeft">Days Left</h5>
                </div>
              </div>
            </div>
            <div class="row" style="width: 100%; margin-left: 0">
              <div class="col-sm-12 progressHolder align-items-center">
                <div class="row" style="width: 100%">
                  <div class="col-sm-10 progressBar" id="referenceDiv"></div>
                </div>
                <div class="numberHours">
                  {{ currentProgram.totalHours }} Hours
                </div>
              </div>
            </div>
            <div class="completedHours text-center" id="targetDiv">
              <h5>{{ currentProgram.hoursCompleted }} Hours</h5>
              <h5>Completed</h5>
              <h2>▼</h2>
            </div>
          </div>
        </div>
      </div>
    </card>
    <card class="basicCard">
      <h1>Welcome to Masterclass</h1>
      <div class="row">
        <div class="col-sm-3">
          <div
            class="bigBlackButton introButton"
            @click="goToPage('instructorIntro')"
          >
            Instructor Introduction
          </div>
        </div>
        <div class="custom-col-sm-1"></div>
        <div class="col-sm-3">
          <div
            class="bigBlackButton introButton"
            @click="goToPage('schoolIntro')"
          >
            School Introduction
          </div>
        </div>
        <div class="custom-col-sm-1"></div>
        <div class="col-sm-3">
          <div
            class="bigBlackButton introButton"
            @click="goToPage('courseIntro')"
          >
            Course Introduction
          </div>
        </div>
      </div>
    </card>
    <card class="basicCard">
      <h2>Featured Lessons</h2>
      <div class="row">
        <div
          class="col-sm-2"
          v-for="lesson of currentProgram.featuredLessons"
          v-bind:key="lesson.id"
        >
          <div class="bigBlackButton" @click="goToPage(lesson.page)">
            {{ lesson.name }}
          </div>
        </div>
      </div>
    </card>
    <card class="basicCard">
      <h2>{{ currentProgram.name }} Pilot Lessons</h2>
      <div class="row">
        <div
          class="col-sm-2"
          v-for="lesson of currentProgram.allLessons"
          v-bind:key="lesson.id"
        >
          <div class="bigBlackButton" @click="goToPage(lesson.page)">
            {{ lesson.name }}
          </div>
        </div>
      </div>
    </card>
    <coming-soon-modal />
  </div>
</template>
<script>
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  components: { ComingSoonModal },
  data() {
    return {
      student: null,
      instructor: null,
      profilePicPath: null,
      rightLogoPath: null,
      currentProgram: null,
    };
  },
  mounted() {
    this.getStudent();
    this.getInstructor();
    this.getProgram();
    this.$nextTick(() => {
      this.getDynamicWidth();
    });
    window.onload = this.getDynamicWidth;
    window.onresize = this.getDynamicWidth;
  },
  methods: {
    getStudent() {
      this.student = {
        id: 1,
        full_name: "Tyler Johnson",
        lastSessionId: 7,
        programId: 1,
        balance: 300,
      };
      this.getProfilePic();
    },
    getInstructor() {
      this.instructor = {
        full_name: "Tyler Johnson",
      };
      this.getProfilePic();
    },
    getProfilePic() {
      this.profilePicPath = "/static/img/faces/face-0.jpg";
      this.rightLogoPath = "/static/img/v-w-private-logo.png";
    },
    getProgram() {
      this.currentProgram = {
        id: 1,
        name: "Private",
        startDate: new Date("February 01, 2024 00:00:00"),
        endDate: new Date("July 13, 2024 00:00:00"),
        hoursCompleted: 45,
        totalHours: 70,
        featuredLessons: [
          {
            id: 1,
            name: "Lifestyle",
            page: "Lifestyle Lesson",
          },
          {
            id: 2,
            name: "How to Study",
            page: "How to Study Lesson",
          },
          {
            id: 3,
            name: "Benefits",
            page: "Benefits Lesson",
          },
          {
            id: 4,
            name: "Negotiations",
            page: "Negotiations Lesson",
          },
          {
            id: 5,
            name: "Interview Prep",
            page: "Interview Prep Lesson",
          },
          {
            id: 6,
            name: "Working at an Airline",
            page: "Working at an Airline Lesson",
          },
        ],
        allLessons: [
          {
            id: 1,
            name: "Lifestyle",
            page: "Lifestyle Lesson",
          },
          {
            id: 2,
            name: "How to Study",
            page: "How to Study Lesson",
          },
          {
            id: 3,
            name: "Benefits",
            page: "Benefits Lesson",
          },
          {
            id: 4,
            name: "Negotiations",
            page: "Negotiations Lesson",
          },
          {
            id: 5,
            name: "Interview Prep",
            page: "Interview Prep Lesson",
          },
          {
            id: 6,
            name: "Working at an Airline",
            page: "Working at an Airline Lesson",
          },
          {
            id: 7,
            name: "Lifestyle",
            page: "Lifestyle Lesson",
          },
          {
            id: 8,
            name: "How to Study",
            page: "How to Study Lesson",
          },
          {
            id: 9,
            name: "Benefits",
            page: "Benefits Lesson",
          },
          {
            id: 10,
            name: "Negotiations",
            page: "Negotiations Lesson",
          },
          {
            id: 11,
            name: "Interview Prep",
            page: "Interview Prep Lesson",
          },
          {
            id: 12,
            name: "Working at an Airline",
            page: "Working at an Airline Lesson",
          },
        ],
      };
    },
    goToDocuments() {
      alert("Went to documents page!");
    },
    goToStaticSystem() {
      alert("Went to static system!");
    },
    calculateDaysLeft() {
      let mili = this.currentProgram.endDate - new Date();
      let sec = mili / 1000;
      let min = sec / 60;
      let hour = min / 60;
      return Math.floor(hour / 24);
    },
    goToPage(page) {
      alert("Went to " + page);
    },
    getDynamicWidth() {
      const referenceDiv = document.getElementById("referenceDiv");
      const targetDiv = document.getElementById("targetDiv");
      const referenceWidth = referenceDiv.offsetWidth;

      targetDiv.style.left =
        55 +
        Math.round(
          (this.currentProgram.hoursCompleted /
            this.currentProgram.totalHours) *
            referenceWidth,
        ) +
        "px";
    },
  },
};
</script>
<style scoped>
h1,
h2,
h4,
h5 {
  margin: 0;
}
p {
  font-size: 12px;
  padding: 1em 1em;
}
h1,
h2 {
  font-weight: bold;
}
h5 {
  color: grey;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.basicCard {
  margin: 1em 2em;
  border-color: transparent;
}
#profilePic {
  padding: 0.25em;
  border-radius: 1em;
}
.cardTitles {
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: black;
}
.lightGreyButton {
  margin: 1em;
  padding: 0 0.3em;
  background-color: #8e9093;
  color: #e7e7e7;
  border-radius: 0.3em;
  border-color: transparent;
  letter-spacing: 0.15em;
  font-weight: lighter;
  font-size: 18px;
}
.bigBlackButton {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding: 2em 0;
  background-color: black;
  color: white;
  height: 100px;
  border-radius: 1em;
  border-color: transparent;
  font-weight: normal;
  font-size: 24px;
  justify-content: center;
  cursor: pointer;
}
.bigBlackButton:hover {
  transform: scale(1.01);
}
.introButton {
  font-weight: bold;
}
.align-items-center {
  display: flex;
  align-items: center;
}
.text-center {
  text-align: center;
}
.customCard {
  width: 100%;
  height: 100%;
  align-content: space-evenly;
  background-color: #f0f0f0;
  border-radius: 2em;
  padding: 1em 1.5em;
}
.hashTag {
  margin-left: 0.75em;
  clear: left;
  text-align: center;
  font-size: 16px;
  background-color: black;
  color: white;
  padding: 0;
  border-radius: 2em;
}
.arrowBtn {
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 28px;
  font-weight: lighter;
  bottom: 30px;
  right: 45px;
}
.arrowBtn:hover {
  transform: scale(1.05, 1.05);
}
.redText {
  color: #dd2025;
  margin-top: -10px;
}
.daysLeft {
  font-size: 18px;
  background-color: #dd2025;
  color: white;
  padding: 0;
  margin: 0;
}
.progressHolder {
  margin-top: 20px;
  background-color: #d0d0d0;
  border-radius: 2em;
  padding: 10px 30px;
  font-size: 10px;
  padding-right: 5px;
}
.progressBar {
  height: 20px;
  background-color: white;
  border-radius: 2em;
}
.numberHours {
  position: relative;
  margin: 0;
  font-size: 13px;
  width: 15%;
}
.completedHours {
  position: absolute;
  margin: 0;
  padding: 0;
  z-index: 10;
  bottom: 30px;
}
.completedHours h5 {
  color: black;
  margin: -10px;
  padding: 0;
}
.completedHours h2 {
  text-align: left;
  margin-top: -5px;
  transform: scale(1, 0.75);
}
.custom-col-sm-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  -ms-flex: 0 0 12.5%;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
button {
  border-style: solid;
}
</style>
